export default __webpack_public_path__ + "static/media/clear-icon.b344119a.svg";